module.exports = __webpack_public_path__ + "static/media/logo_twitterfeel.0eedbdd0.webp";